<template>
  <div class="shipping-address">
    <div class="shipping-address-header">
      <el-button type="primary" size="small" @click="handleDetail(null)">{{
        $t("shipping.create")
      }}</el-button>
    </div>

    <el-table :data="tableData" ref="table">
      <el-table-column :label="$t('shipping.name')">
        <template slot-scope="scope">
          <div class="row-product-name">
            <div class="content">
              <p class="title">
                {{ scope.row.ReceivingName }}
              </p>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column :label="$t('shipping.phoneNumber')">
        <template slot-scope="scope">
          <div class="row-product-name">
            <div class="content">
              <p class="title">
                {{ scope.row.PhoneNumber }}
              </p>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column :label="$t('shipping.postalCode')">
        <template slot-scope="scope">
          <div class="row-product-name">
            <div class="content">
              <p class="title">
                {{ scope.row.PostalCode }}
              </p>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column :label="$t('shipping.address')">
        <template slot-scope="scope">
          <div class="row-product-name">
            <div class="content">
              <p class="title">
                {{ scope.row.ReceivingAddress }}
              </p>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column :label="$t('shipping.default')">
        <template slot-scope="scope">
          <div class="row-product-check" v-if="scope.row.IsDefult">
            <img src="@/assets/img/icon_tick_select.png" />
          </div>
        </template>
      </el-table-column>
      <el-table-column :label="$t('shipping.operate')">
        <template slot-scope="scope">
          <el-button-group>
            <el-button
              size="mini"
              type="primary"
              @click="handleDetail(scope.row.URId)"
              >{{ $t("shipping.edit") }}</el-button
            >
            <el-button
              size="mini"
              type="danger"
              @click="handleDelete(scope.row.URId)"
              >{{ $t("shipping.delete") }}</el-button
            >
          </el-button-group>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      class="pagination"
      :current-page="page"
      :page-sizes="[1, 5, 10, 15, 20, 50, 100]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="count"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    />
  </div>
</template>
<script>
import { mapActions } from "vuex";
export default {
  name: "ShippingAddress",
  data() {
    return {
      page: 1,
      pageSize: 20,
      count: 0,
      lastPage: 0,
      tableData: []
    };
  },
  mounted() {
    this.request(this.page);
  },
  methods: {
    ...mapActions(["getCUser"]),
    request(page) {
      let param = {
        PageIndex: page,
        PageSize: this.pageSize
      };
      this.$api.cUser
        .loadUsersReceiving(param)
        .then(res => {
          this.page = res.meta.page;
          this.count = res.meta.total;
          this.lastPage = res.meta.lastPage;
          this.tableData = res.data;
        })
        .catch(err => {
          this.$message.error(err.message);
        });
    },
    handleDelete(id) {
      let param = {
        URId: id
      };
      this.$api.cUser
        .deleteUsersReceiving(param)
        .then(() => {
          this.request(this.page);
          this.$message.success(this.$t("B2C.success"));
        })
        .catch(err => {
          this.$message.error(err.message);
        });
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.request(this.page);
    },
    handleCurrentChange(val) {
      this.page = val;
      this.request(this.page);
    },
    handleDetail(id) {
      this.$router.push({
        path: "/addressDetail",
        query: { URId: id ? id : "" }
      });
    }
  }
};
</script>
<style lang="scss" scoped>

.shipping-address {
  padding: 0px 30px 30px;
  .shipping-address-header {
    margin: 20px 0px;
  }
  .image {
    width: 66px;
    height: 66px;
    flex-shrink: 0;
    cursor: pointer;
  }
  .row-product-name {
    display: flex;

    .content {
      font-size: 12px;
      flex: 1;
      position: relative;
      p {
        margin: 0;
      }
      .title {
        color: #333;
        width: 7rem;
      }
      .labelimg {
        position: absolute;
        top: 0;
        left: 8rem;
      }
      .id {
        margin-top: 5px;
        color: #999;
      }
      .model {
        margin-top: 5px;
        color: #999;
      }
      .count {
        margin-top: 5px;
        color: #999;
      }
    }
  }
  .row-product-price {
    margin: 0;
    font-size: 12px;
    color: #ff5852;
  }
  .row-product-state {
    margin: 0;
    font-size: 12px;
    color: #25b9ff;
  }
  .row-product-check{
    line-height: 10px;
  }
  .el-pagination {
    margin-top: 2%;
    margin-bottom: 2%;
    text-align: right;
  }
}
</style>
